import React from 'react';
import PropTypes from 'prop-types';
import { emptyObject } from 'ui-components/default-props/empty';
import { useModal } from '../../../../../hooks/use-modal';
import { ProviderTableHeader } from '../../components';
import { useProvidersGridContext } from '../../providers-grid-context';
import { InviteModals } from '../invite-modals';
import messages from './messages';

export const VendorListHeader = ({ showInactive, toggleInactive }) => {
  const { isOpen: isInviteModalOpen, open: openInviteModal, close: closeInviteModal } = useModal();

  const { vendors } = useProvidersGridContext();

  const closeInviteModalAndRefresh = () => {
    vendors.updateList();
    closeInviteModal();
  };

  return (
    <>
      <InviteModals
        canResendInvite={false}
        closeInviteModal={closeInviteModalAndRefresh}
        isOpenInviteModal={isInviteModalOpen}
        provider={emptyObject}
      />
      <ProviderTableHeader
        buttonMessage={messages.addAVendor}
        headerMessage={messages.vendors}
        onBtnClick={openInviteModal}
        showInactive={showInactive}
        toggleInactive={toggleInactive}
      />
    </>
  );
};

VendorListHeader.propTypes = {
  showInactive: PropTypes.bool.isRequired,
  toggleInactive: PropTypes.func.isRequired,
};
